/**
 * Where each SSO button starts its login. Shared by the web app and the admin portal
 * (@web alias). These must be routes identity-service actually registers: Google and
 * SAML used to point at /v1/auth/sso/google/authorize and /v1/auth/saml/login, which
 * do not exist.
 */
const START_PATHS: Record<string, string> = {
  azure:  '/v1/auth/azure/login',
  google: '/v1/auth/google/login',
  saml:   '/v1/auth/saml2/login',
};

/** Login start URL for a provider key from /v1/auth/providers, or null if unknown. */
export function ssoLoginPath(providerKey: string, redirectTo: string, apiBase = ''): string | null {
  const path = START_PATHS[providerKey];
  return path ? `${apiBase}${path}?redirect_to=${encodeURIComponent(redirectTo)}` : null;
}
